<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>


    <div id="page-user-list">
    
      <vs-card>
       
      <vs-table search stripe :data="entrevistas">
       
  <template  slot="header">
              <!-- <vs-button v-if="canAddPayroll" @click="popupAdd=true" icon-pack="feather" icon="icon-plus"  color="primary" type="border" class="mb-2">Adicionar vaga</vs-button> -->
           
            </template>
    <template slot="thead">
      <vs-th sort-key="name">Candidato</vs-th>
      <vs-th sort-key="surname">Tipo</vs-th>
      <vs-th sort-key="email">Data</vs-th>
      <vs-th sort-key="email">Hora de inicio</vs-th>
      <vs-th sort-key="email">Hora de termino</vs-th>
      <vs-th sort-key="email">Local</vs-th>
      <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
      <vs-th></vs-th>
      <!-- <vs-th sort-key="id">Nro</vs-th> -->
    </template>
  
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        
  <vs-td >
    {{ data[indextr].candidate.name }}  {{ data[indextr].candidate.surname }}
        </vs-td>
        <vs-td>
         
          <span v-if="data[indextr].type=='in-person'"> Presencial </span>
          <span v-else> Remoto </span>
      </vs-td>
        
        
      <vs-td>  {{ data[indextr].date }} </vs-td>
    
        <vs-td>  {{ data[indextr].start_time }} </vs-td>
     
        <vs-td>
          <vs-td>  {{ data[indextr].end_time }} </vs-td>
</vs-td>
<vs-td>  {{ data[indextr].location }} </vs-td>



        <vs-td class="whitespace-no-wrap" >
          <vs-row>
            <vs-button  class="mr-2" color="success" size="small" hover:text-danger  icon-pack="feather" icon="icon-camera"  @click="startCamera">
  Entrevista
</vs-button>
                      <vs-button  color="primary" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEdit(tr)">
  
                      </vs-button>
                      <vs-button  class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openConfirm(tr)"></vs-button>
               </vs-row>
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>
  
        <!-- <vs-td :data="data[indextr].id">
          {{ data[indextr].id }}
        </vs-td> -->
      </vs-tr>
    </template>
  </vs-table>
    <!-- <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div> -->
  </vs-card>
  <vs-popup class="holamundo" title="Entrevista online" :active.sync="video">
    <video ref="video" autoplay></video>
    <button @click="stopCamera">Fechar Câmera</button>
  </vs-popup>
  <vs-popup class="holamundo" title="Actualizar entrevista" :active.sync="popupEdit">
    <div class="vx-row">
  
  <div class="vx-col w-full mb-2">
      <label class="mt-8" for="">Tipo</label>
      <vs-input class="w-full mt-2 mb-5"  type="text" v-model="type" />
      </div>
      <div class="vx-col w-full mb-2">
      <label class="mt-8" for="">Local</label>
      <vs-input class="w-full mt-2 mb-5"  type="text" v-model="location" />
      </div>
      <div class="vx-col w-full mb-2">
      <label class="mt-8" for="">Data</label>
      <vs-input class="w-full mt-2 mb-5"  type="date" v-model="date" />
      </div>
      <div class="vx-col w-1/2 mb-2">
      <label class="mt-8" for="">Hora de inicio</label>
      <vs-input class="w-full mt-2 mb-5"  type="time" v-model="start_time" />
      </div>
      <div class="vx-col w-1/2 mb-2">
      <label class="mt-8" for="">Hoea de termino</label>
      <vs-input class="w-full mt-2 mb-5"  type="time" v-model="end_time" />
      </div>
 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
      </vs-popup>
  

    </div>
  
  </template>
  
  <script>
  import vSelect from 'vue-select'
  import http from "../../../../../http-common";
  import { PermissionsMixin } from "../../../../mixins/permissions"
  // Store Module
  
  // Cell Renderer
  
  
  export default {
    mixins:[PermissionsMixin],
    components: {
      vSelect,
   
      
    },
    data() {
      return {
        video:false,
        videoStream: null,
        popupAdd:false,
        popupEdit:false,
        name:"",
        abbreviation:"",
        type:"",
        components:[],
        component:[
          {
            id:"",
            name:"",
        abbreviation:"",
        type:"",
          }
        ],
        dados:[],
  
  employees:[],
  currentUser:[],
  entrevistas:[],
  
  
      }
    },
  
    mounted() {
      this.initialize();
    },
  
   
    methods: {
      initialize(){
        this.getData();
        // this.getCurrentUser();
      },

     

    async startCamera() {
      try {
        this.videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.video.srcObject = this.videoStream;
        this.video=true
      } catch (error) {
        console.error('Erro ao abrir a câmera:', error);
      }
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());
        this.$refs.video.srcObject = null;
      }
    },
  openConfirm(dados) {
    this.dados=dados
              this.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: `Confirmação`,
                  text: 'Tem certeza que deseja eliminar?' ,
                  accept: this.remove
              })
          },
  
          async remove() {
              //  this.dados=dados
             this.$vs.loading()
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
    
        
  
       http
          .delete(`/salaries/components/${this.dados.id}`, config)
          .then((success) => {
            success;
          
          this.getData(),
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Removido com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
  
     
      },
  
       getCurrentUser() {
         this.$vs.loading()
        
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        http
        .get("/auth/me", config)
          .then((success) => {
             this.$vs.loading.close();
            this.currentUser = success.data.User
            
             this.newArray = this.currentUser.permissions.filter(function (el)
  {
    return el.name =="create Employee"
  
  }
  
  );
  
          })
          .catch((error) => {
            error;
  
            
           
          });
      },
  
      getData() {
        
        //     this.$vs.loading({
        //   container: '#div-with-loading',
        //   scale: 1.0,
        //   type:'sound'
        // })
      
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        
        http
          .get("recruitments/interview", config)
          .then((result) => {
            this.entrevistas = result.data.data
  // alert("2")
          })
          .catch((error) => {
            error;
            //  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            if(error.response.status==401 ){
              this.$router.push('/').catch(() => {})
            }
           
          });
      },
  
             async saveData() {
               this.$validator.validate('nome').then(result => {
          if (result) {
             this.$vs.loading()
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
    
        const data = {
            name:this.name,
            abbreviation:this.abbreviation,
            type:this.type
            
        };
  
       http
          .post("/salaries/components", data, config)
          .then((success) => {
            success;
          this.popupAdd=false,
           this.name="",
            this.abbreviation="",
            this.type="",
          
          this.getData(),
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Componente salaria adicionado com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
          }})
  
     
      },
  
  
  
  
  
   popupOpenEdit(component){
     this.component=component,
           this.popupEdit=true
  
            
          },
  
             async editData() {
          //      this.$validator.validateAll().then(result => {
          // if (result) {
             this.$vs.loading()
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
    
        const data = {
            name:this.component.name,
            abbreviation:this.component.abbreviation,
            type:this.component.type
            
        };
  
        this.$validator.validateAll();
       http
          .put(`/salaries/components/${this.component.id}`, data, config)
          .then((success) => {
            success;
          this.popupEdit=false,
          
          this.getData(),
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Componente salaria actualizado com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
          // }})
  
     
      },
  
  
    
     
  
    
  },
  
  }
  
  </script>
  
  